import styled, { createGlobalStyle } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";

import { i18nFilter, translate } from "app/filters/i18nFilter";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { Badge } from "@similarweb/ui-components";

const i18n = i18nFilter();

const SINGLE_COMPARE_SIMILARITY_TRESHOLD = 0.001;
export const areValuesEqualAvgWithTreshold = (values, treshold = SINGLE_COMPARE_SIMILARITY_TRESHOLD) => {
    const avg = values.reduce((acc, v) => (Number.isFinite(v) ? acc + v : acc), 0) / values.length;
    return values.every((val) => Math.abs(avg - (Number.isFinite(val) ? val : 0)) / avg < treshold);
};

const { carbon, bluegrey } = colorsPalettes;

const BetaBranchLabelWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: ${colorsPalettes.carbon[25]};
    border-radius: 6px;
    padding: 4px 8px;

    [data-automation="badge"] {
        margin-left: 0.5em;
    }
`;

const BetaBranchLabelTitle = styled.div`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const BetaBranchLabel = () => (
    <BetaBranchLabelWrapper>
        <BetaBranchLabelTitle>{i18n("wa.traffic.engagement.beta.label.text")}</BetaBranchLabelTitle>
        <Badge type="beta" />
    </BetaBranchLabelWrapper>
);

const BetaMessageContainer = styled.div`
    background-color: ${bluegrey[100]};
    box-shadow: 0px 3px 6px 0px ${rgba(carbon[500], 0.08)};
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;
    border-radius: 4px;
    grid-row: 2;
    grid-column: 1 / span 2;
    ${setFontVariant("body1", carbon[400])};
    width: 100%;

    .SWReactIcons {
        margin-right: 0.75em;
    }
`;

export const BetaMessagewrapper = styled(FlexRow)`
    margin-top: 0px;
    margin-bottom: 12px;
    padding: 0px 24px;
    box-sizing: border-box;
    align-items: center;
`;

const DisclaimerContainer = styled(BetaMessageContainer)`
    width: unset;
`;

interface MessageProps {
    message?: string;
    messageKey?: string;
}

export const DisclaimerMessage: React.FC<MessageProps> = ({ message = "", messageKey = "" }) => (
    <DisclaimerContainer>
        <SWReactIcons
            iconName="info"
            size="xs"
        />
        <span>{message || translate(messageKey)}</span>
    </DisclaimerContainer>
);

export const BetaMessage: React.FC<MessageProps> = ({ message = "", messageKey = "" }) => (
    <BetaMessageContainer>
        <SWReactIcons
            iconName="info"
            size="xs"
        />
        <span>{message || i18n(messageKey)}</span>
    </BetaMessageContainer>
);

export const WidgetBetaMessageWrapper = styled.div`
    margin-top: 0;

    ${BetaMessageContainer} {
        margin: 0;
        padding: 4px 8px;
    }
`;

const WidgetBetaBranchLabelWrapper = styled.div`
    position: absolute;
    z-index: 1;
    max-width: 35%;
`;

const WidgetBetaBranchLabelStyles = createGlobalStyle`
    .AudienceWidgetWrapper {
        position: relative;
        
        .addToDashboard {
            display: none;
        }
    }
`;

const WidgetBetaBranchLabel = (props) => {
    const { positionStyle = { top: "12px", right: "12px" } } = props;

    return (
        <>
            <WidgetBetaBranchLabelStyles />
            <WidgetBetaBranchLabelWrapper style={positionStyle}>
                <BetaBranchLabel />
            </WidgetBetaBranchLabelWrapper>
        </>
    );
};
